import React from 'react';
export var initialValue = {
  eligibilityResults: {
    result: {},
    searchData: {},
    isResultsLoading: false,
    isMarketsDataLoading: false,
    isResultsFailed: false,
    alreadyAppliedMessage: '',
    hasFetchedMarketsData: false
  },
  fetchResults: null
};
var EligibilityResultsContext = /*#__PURE__*/React.createContext(initialValue);
export default EligibilityResultsContext;